export const LAST_ACTIONS_TIME_SELECTORS = [
  { daysAgo: 0, title: 'TODAY' },
  { daysAgo: 3, title: 'LAST_THREE_DAYS' },
  { daysAgo: 14, title: 'LAST_TWO_WEEKS' },
];
